/**
* モーダルのコンストラクタ
* @constructor
* @param {selector} el - セレクタ
*/
module.exports = Modal = function(el){
  this.element = $(el);
  this.init()
};

/**
* initialize
*/
Modal.prototype.init = function(){
  var self = this;

  this.win = $(window);
  this.doc = $(document);
  this.checkDevice();
  this.resize();
  this.initModal();
  this.event();
};

/**
* モーダル作る
*/
Modal.prototype.initModal = function(){
  var self = this;
  if(!$('.js-modal').length){
    var html = '';
    html += '<div class="sc-modal js-modal">';
    html += '<div class="sc-modal-content js-modal-content" />';
    html += '</div>';
    $('body').append('<div class="sc-modal-overlay js-modal-overlay" />').append(html);
  };

  this.modal = $('.js-modal');
  this.modalOverlay = $('.js-modal-overlay');
  this.modalHtml = $('.js-modal-content');
};

/**
* イベント
*/
Modal.prototype.event = function(){
  var self = this;

  this.element.on('click', function(e){
    if(self.device === 'pc'){
      e.preventDefault();
      var href = $(this).attr('href');
      self.getData(href);
    }
  });

  this.doc.on('click', '.js-modal-close, .js-modal-overlay', function(e){
    e.preventDefault();
    self.modalRemove();
  });
};

/**
* ajax
* @param {string} url - 取得するURL
*/
Modal.prototype.getData = function(url){
  var self = this;

  $.ajax({
    url: url,
    dataType: 'html'
  }).then(
    function(data){
      self.renderContent(data);
      ga('send', 'pageview', url);
    },
    function(e){
      alert('通信エラーが発生しました');
    }
  );
};

/**
* モーダルの中身描画
* @param {string} data - ajaxで取得したDOM
*/
Modal.prototype.renderContent = function(data){
  var self = this;
  var $content = $(data).find('.sc-main');
  var $footer = $content.find('.sc-footer');
  var $printBtn = $content.find('.sc-recipeItemPrintBtn');
  var $closeBtn = $content.find('.sc-recipeItemBackBtn');
  var $closeBtnImg = $closeBtn.find('img');
  var closeBtnSrc = $closeBtnImg.attr('src').replace('/sp/recipe/recipe_item_backbtn.png', '/pc/recipe/recipe_item_closebtn.png');
  $footer.remove();
  $closeBtn.addClass('js-modal-close');
  $closeBtnImg.attr('src', closeBtnSrc);
  if($('body').hasClass('js-device--desktop')){
    $printBtn.addClass('is-visible');
  }
  this.modalHtml.prepend($content.html());

  var images = [];
  var image = this.modalHtml.find('img');
  for(var i = 0; i < image.length; i++){
    images.push(image[i].src);
  }
  this.preloadAll(images).done(function(){
    self.modalOpen();
  });
};

/**
* 画像プリロード（ALL）
* @param {object} arr - 配列
*/
Modal.prototype.preloadAll = function(arr){
  var self = this;

  var defers = arr.map(function(src){
    return self.preload(src);
  });
  return $.when.apply($, defers);
};

/**
* 画像プリロード
* @param {string} src - パス
*/
Modal.prototype.preload = function(src){
  var self = this;

  var defer = $.Deferred();

  var img = new Image();
  img.src = src;
  img.onload = function(){
    defer.resolve();
  }
  img.onerror = function(){
    defer.reject();
  }

  return defer.promise();
};

/**
* モーダル開く
*/
Modal.prototype.modalOpen = function(){
  var self = this;
  var scrollTop = this.win.scrollTop();
  this.modalOverlay.addClass('is-active');
  if(this.modalHtml.height() > this.win.height()){
    this.modal.addClass('is-scroll');
  }
  self.modalPositionSetting(scrollTop);
  self.modal.scrollTop(0).addClass('is-active');
};

/**
* モーダル閉じる
*/
Modal.prototype.modalRemove = function(){
  this.modalOverlay.removeClass('is-active');
  this.modal.removeClass('is-active is-scroll').removeAttr('style');
  this.modalHtml.empty();
};

/**
* モーダル位置調整
* @param {number} _t - scroll top
*/
Modal.prototype.modalPositionSetting = function(_t){
  var self = this;
  this.modal.css({
    'top': _t + this.win.height() / 2 - this.modal.outerHeight() / 2,
    'bottom': 'inherit'
  });
};

/**
* リサイズ
*/
Modal.prototype.resize = function(){
  var self = this;
  var timer = false;
  this.win.on('resize', function(){
    if(timer !== false){
      clearTimeout(timer);
    }
    timer = setTimeout(function(){
      var scrollTop = self.win.scrollTop();
      self.modalPositionSetting(scrollTop);
      self.checkDevice();
    },1000);
  });
};

/**
* デバイスチェック
*/
Modal.prototype.checkDevice = function(){
  this.device = $('.sc-main').css('position') == 'relative' ? 'sp' : 'pc';
}



//////////////////
// WEBPACK FOOTER
// ./js/_modules/modal.js
// module id = 6
// module chunks = 0